import React, { Suspense, useContext } from 'react';
import { BrowserRouter } from 'react-router-dom';

import MainContent from '../../molecules/MainContent/MainContent';
import Footer from '../../molecules/Footer/Legacy/Footer';
import { AirDropContext } from '../../../utils/AirDropProvider';

function Legacy() {
  const { backgroundImageUrl, cloudfrontRootUrl } = useContext(AirDropContext);

  const isAbsoluteUrl = (url: string = '') => url.indexOf('http://') === 0 || url.indexOf('https://') === 0;

  const LOGIN_PATH = /^(\/login\/static\/img)/;
  const CLOUDFRONT_BASE_URI = `${cloudfrontRootUrl}/img`;

  const getImageUrl = () => {
    const url = backgroundImageUrl;
    if (url && isAbsoluteUrl(url)) {
      return url;
    }
    return url?.replace(LOGIN_PATH, CLOUDFRONT_BASE_URI);
  };

  const bgStyle = getImageUrl() ? { backgroundImage: `url('${getImageUrl()}')` } : {};
  return (
    <div id="pageWrapperLegacy" style={bgStyle}>
      <Suspense>
        <BrowserRouter>
          <MainContent />
          <Footer />
        </BrowserRouter>
      </Suspense>
    </div>
  );
}

export default Legacy;
